import {
  PROFILE_STATUS,
  PSP_OPERATIONS,
  PSP_OPERATION_STATUS,
  PSP_OPERATIONS_CATEGORIES,
  PSP_OPERATION_FILE_ITEM_TYPE,
  DEPOSIT_ADMIN_ACTION,
  PSP_WIZARD_STEP,
  WALLET_ACCOUNT_TYPE,
  TRADING_ACCOUNT_TYPE,
  TRADING_PLATFORM_TYPE,
  TRADING_PLATFORM_SECTION_TYPE,
  EXECUTION_TYPE,
  WALLET_OPERATION_TRANSFER_TYPE,
  Q_FORM_STATUS,
  ROLES,
  DOCUMENT_STATUS,
  DOCUMENT_TYPE,
  DOCUMENT_SUB_TYPE,
  FILE_TYPE,
  ISSUE_STATUS,
  ITEM_TYPE,
  ACTION_TYPE,
  GROUP_MAPPING,
  JOB_STATUS,
  UNIT,
  KNOWN_INTERFACE,
  Q_FORM_TYPE,
  PAYMENT_SUMMARY_TYPE,
  LOCATION,
  LEGAL_TYPE,
  LEGAL_SECTION_TYPE,
  CLIENT_SOURCE_TYPE,
  TRANSFER_ACCOUNT_TYPE,
  DOCUMENT_CATEGORY,
  USER_DOCUMENT_TYPE,
  USER_STATEMENT_ACCOUNT_STATUS,
  SHORT_LINK_TYPE,
  SHORT_LINK_VERSION,
  SHORT_LINK_STATUS,
  KYC_STATUS,
  PSP_OPERATION_PROMOTE_TYPE,
  CLIENT_APP_TYPE,
  KYT_VERIFICATION_API_LOG_TYPE,
  KYT_VERIFICATION_STATUS,
  TRADING_ACCOUNT_FORM_TYPE,
  ACCOUNT_TYPE_PREFIX,
  COPY_TYPE,
  OPERATION_PARAMS,
  LIST_APPEARANCE,
  CHART_TYPE,
  NOTIFICATION_TYPE,
  MAM_MASTER_ACCOUNT_STATUS,
  MAM_LINK_STATUS,
  REASSIGNMENT_TYPE,
  TRADING_BONUS_STATUS,
  TRADING_GROUP_TYPE,
  PREAUTHORIZED_TYPE,
  COMPONENT_CLASS_TAGS,
  COUNTRY_ACCESS_TYPE,
} from 'global.enums';

export const CONSTANTS = {
  PROFILE_STATUS,
  PSP_OPERATIONS,
  PSP_OPERATION_STATUS,
  PSP_OPERATIONS_CATEGORIES,
  PSP_OPERATION_FILE_ITEM_TYPE,
  DEPOSIT_ADMIN_ACTION,
  PSP_WIZARD_STEP,
  WALLET_ACCOUNT_TYPE,
  TRADING_ACCOUNT_TYPE,
  TRADING_PLATFORM_TYPE,
  TRADING_PLATFORM_SECTION_TYPE,
  EXECUTION_TYPE,
  WALLET_OPERATION_TRANSFER_TYPE,
  Q_FORM_STATUS,
  ROLES,
  DOCUMENT_STATUS,
  DOCUMENT_TYPE,
  DOCUMENT_SUB_TYPE,
  FILE_TYPE,
  ISSUE_STATUS,
  ITEM_TYPE,
  ACTION_TYPE,
  GROUP_MAPPING,
  JOB_STATUS,
  UNIT,
  KNOWN_INTERFACE,
  Q_FORM_TYPE,
  PAYMENT_SUMMARY_TYPE,
  LOCATION,
  LEGAL_TYPE,
  LEGAL_SECTION_TYPE,
  CLIENT_SOURCE_TYPE,
  TRANSFER_ACCOUNT_TYPE,
  DOCUMENT_CATEGORY,
  USER_DOCUMENT_TYPE,
  USER_STATEMENT_ACCOUNT_STATUS,
  SHORT_LINK_TYPE,
  SHORT_LINK_VERSION,
  SHORT_LINK_STATUS,
  ALL_COUNTRIES_COUNTRY: 'AllCountries',
  NOT_ALLOWED_COUNTRY: 'NotAllowed',
  COUNTRIES_WITH_REQUIRED_TWO_SIDES_DRIVING_LICENSE: ['Thailand', 'Philippines'],
  CHINESE_REGION_COUNTRIES: ['China', 'Taiwan', 'HongKong', 'Macau'],
  DEFAULT_DOCUMENT_TYPE: 'NationalId',
  SIGNATURE_DOCUMENT_TYPE: 'Signature',
  START_UNIX_DATE: '1970-01-01T00:00:00',
  DEFAULT_TIME_ZONE: 'EET', // Meta Trader Time - Eastern European Time (EET) (UTC+02:00; UTC+03:00)
  KYC_STATUS,
  PSP_OPERATION_PROMOTE_TYPE,
  CLIENT_APP_TYPE,
  KYT_VERIFICATION_API_LOG_TYPE,
  KYT_VERIFICATION_STATUS,
  DEFAULT_RANGE_VALUE: '[*,*]',
  TRADING_ACCOUNT_FORM_TYPE,
  ACCOUNT_TYPE_PREFIX,
  COPY_TYPE,
  OPERATION_PARAMS,
  PHONE_LENGTH: 15,
  LIST_APPEARANCE,
  DEFAULT_SELECT_OPTION_VALUE: '',
  CHART_TYPE,
  NOTIFICATION_TYPE,
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm:ss',
  REFERRAL_TOKEN_PARAMETER_NAME: 'referralToken',
  NEW_USER: 'newUser',
  HIGHEST_SORT_ORDER: 9999,
  INPUT_LENGTH: 256,
  TEXTAREA_LENGTH: 1024,
  MAM_MASTER_ACCOUNT_STATUS,
  MAM_LINK_STATUS,
  REASSIGNMENT_TYPE,
  TRADING_BONUS_STATUS,
  ZERO_LENGTH: 0,
  MIN_CARD_ACCOUNT_NUMBER_LENGTH: 12,
  MAX_CARD_ACCOUNT_NUMBER_LENGTH: 100,
  MIN_STOP_COPY_VIA_MARGIN_PERCENT_LEVEL: 100,
  MAX_MARGIN_PERCENT_LEVEL: 1000000000,
  MAX_DECIMAL_VALUE: 79228162514264337593543950335n,
  TRADING_GROUP_TYPE,
  PREAUTHORIZED_TYPE,
  ACCEPTED_FILE_TYPE: 'image/jpeg, image/png, application/pdf',
  COMPONENT_CLASS_TAGS,
  DEFAULT_GRID_PARAMS: { skip: 0, take: 15 },
  DEFAULT_SEARCH_PARAMS: { skip: 0, take: 10 },
  AMOUNT_PRECISION: 2,
  COUNTRY_ACCESS_TYPE,
};

export const REGEX_CONSTANTS = {
  // eslint-disable-next-line no-useless-escape
  ONLY_ENG_AND_DIGITS_PATTERN: /^[a-zA-Z0-9@.,_ \+\-\/\*\']+$/,
  // eslint-disable-next-line no-useless-escape
  ONLY_ENG_LETTERS_WITH_SPACE_PATTERN: /^[a-zA-Z\-\ ']+$/,
  ONLY_CHINESE_LETTERS_PATTERN: /^[\p{Script=Han}\s]+$/u,
  // eslint-disable-next-line no-useless-escape
  ONLY_ENG_DIGITS_SPECIAL_CHARS_PATTERN: /^[~`!@#$%^&*()_+\-=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/,
  NO_WHITESPACE_PATTERN: /^\S*$/,
  ONLY_DIGITS_PATTERN: /^[-+]?\d*\.?\d*$/g,
  ONLY_NOT_NEGATIVE_DIGITS_PATTERN: /^[+]?\d*\.?\d*$/g,
};

export default CONSTANTS;
